import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import LanguageSwitcher from '../../../components/feature/LanguageSwitcher';

export default function Navigation() {
  const [isScrolled, setIsScrolled] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white shadow-md' : 'bg-transparent'}`}>
      <div className="max-w-7xl mx-auto px-8 py-6 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <img 
            src="https://static.readdy.ai/image/9c9ac816b13094cc8d77dd2c904cea49/d34cd039686a7dceae081bba4b9a7591.png" 
            alt="Stichting IPN Logo" 
            className="h-12 w-auto object-contain animate-pulse"
            style={{ animationDuration: '3s' }}
          />
          <div className="flex flex-col animate-pulse" style={{ animationDuration: '3s' }}>
            <span className={`text-xl font-bold ${isScrolled ? 'text-[#1A2332]' : 'text-white'}`}>Stichting IPN</span>
            <span className={`text-xs ${isScrolled ? 'text-gray-600' : 'text-white/80'}`}>Interpreters & Professionals Network</span>
          </div>
        </div>
        
        <div className="flex items-center gap-8">
          <button onClick={() => scrollToSection('home')} className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${isScrolled ? 'text-[#1A2332] hover:text-[#C9A961]' : 'text-white hover:text-[#C9A961]'}`}>
            {t('nav.home')}
          </button>
          <button onClick={() => scrollToSection('directory')} className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${isScrolled ? 'text-[#1A2332] hover:text-[#C9A961]' : 'text-white hover:text-[#C9A961]'}`}>
            {t('nav.directory')}
          </button>
          <button onClick={() => scrollToSection('knowledge')} className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${isScrolled ? 'text-[#1A2332] hover:text-[#C9A961]' : 'text-white hover:text-[#C9A961]'}`}>
            {t('nav.knowledge')}
          </button>
          <button onClick={() => scrollToSection('impact')} className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${isScrolled ? 'text-[#1A2332] hover:text-[#C9A961]' : 'text-white hover:text-[#C9A961]'}`}>
            {t('nav.impact')}
          </button>
          <button onClick={() => scrollToSection('about')} className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${isScrolled ? 'text-[#1A2332] hover:text-[#C9A961]' : 'text-white hover:text-[#C9A961]'}`}>
            {t('nav.about')}
          </button>
          <button onClick={() => scrollToSection('contact')} className={`px-6 py-2.5 bg-[#C9A961] text-[#1A2332] rounded-full text-sm font-semibold hover:bg-[#B89851] transition-colors whitespace-nowrap cursor-pointer`}>
            {t('nav.contact')}
          </button>
          <LanguageSwitcher />
        </div>
      </div>
    </nav>
  );
}
